<template>


<div style="margin: 5px;">
    <InputGroup>
    <InputGroupAddon>Sourcer Contact</InputGroupAddon>
    <InputText v-model="value"  :disabled="disabled"/>
    
</InputGroup>
</div>

  <!--   <div class="textbox">
        <label>Sourcer Contact:</label>
        <InputText v-model="value"  :disabled="disabled"/>
    </div> -->
</template>  
<script>

export default {
    props: ["modelValue", 'disabled'],
    emits: ["update:modelValue"],
    data() {
        return {
            value: ""
        }
    },
    created(){
        this.value = this.modelValue
        //console.log('MySourcerContact.................')
        //console.log(this.modelValue)
        //console.log(this.value)
    },
    mounted(){
        this.value = this.modelValue
    },
    watch: {
            modelValue: function () {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.value = this.modelValue
            },
            value: function (newVal) {
              // watch it
            //  console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
            },
          },
}
</script>
  
  